import { findModuleInMenu } from "../../helpers/Utils"
import _axios from "../../libs/axios"
import { NotificationManager } from "../../components/common/react-notifications"
export default (context) => {
  const M = "admStudent."
  const itemAdmRelatives = {
    id: 1,
    icon: 'simple-icon-people',
    name: `admUser.relatives`,
    onClick: (row, ctx) => {
      const index = ctx.view.extras.itemsInRowsTable.findIndex(f => f.id === 1)
      ctx.view.extras.itemsInRowsTable[index].form.name = `Familiares de: ${row.name}`
    },
    form: {
      name: 'Familiares',
      remapGET: () => {
         return {
           studentId: context.state.idItemPreSelected,
           dependantId: context.state.idItemPreSelected
         }
      },
      detailGrid: () => {
        return {
          module: 'admRelatives',
          filterBy: () => { return { type: 5, dependantId: context.state.idItemPreSelected } }
        }
      },
      okMsg: 'Ok',
      fields: [
        { name: "studentId", value: 0, type: "hidden" }
      ],
      onSuccess: (r) => { },
      onError: (e) => { }
    }
  }
  const itemAdmAudit = {
    id: 2,
    icon: 'simple-icon-check',
    name: `admUser.auditHistory`,
    onClick: (row, ctx) => {
      const index = ctx.view.extras.itemsInRowsTable.findIndex(f => f.id === 2)
      ctx.view.extras.itemsInRowsTable[index].form.name = `Historial / Auditoria: ${row.name}`
    },
    form: {
      name: 'Historial / Auditoría',
      detailGrid: () => {
        return {
          module: 'admAudit',
          parentIdField: null,
          filterBy: () => { return {userId: context.state.idItemPreSelected} }
        }
      },
      okMsg: 'Ok',
      fields: [],
      onSuccess: (r) => { },
      onError: (e) => { }
    }
  }
  let itemsInRowsTable = []
  const admRelatives = findModuleInMenu(context.props.menuItems, "id", "admRelatives")
  const admAudit = findModuleInMenu(context.props.menuItems, "id", "admAudit")
  if (admRelatives) itemsInRowsTable.push(itemAdmRelatives)
  if (admAudit) itemsInRowsTable.push(itemAdmAudit)

  const moduleConfig = {
    config: {
      pageSize: 40,
      list: false,
      remapRow: (form, res, action, resUpload) => {
        form.img = form.face
        form.name = `${form.last} ${form.last2?? ''}, ${form.name}`
        if (resUpload?.url) form.img = `${resUpload.url}?date=${Date.now()}`
        return form
      }
    },

    actions: {
      create: true,
      edit: true,
      delete: true,
      print: true,
      export: true,
      search: {
        by: "search"
      },
      import: {
        templateFile: "StudentsImport.xlsx"
      }
    },

    extras: {
      items: [
        {id: 0, icon: 'simple-icon-refresh', name: 'Sincronizar con Classroom', onClick: () => { 
          context.props.setLoader(true)
          _axios
            .post(`/admStudent/syncclassroom`)
            .then(r => {
              context.props.setLoader(false)
              if (r.status >= 0) {
                console.log(r)
              }
              if (r.msg) NotificationManager[r.status >= 0 ? "success" : "error"](r.msg, "", 5000, null, null, 'outline')
            }).catch(e => context.props.setLoader(false))
        }}
      ],
      maxItems: 1,
      maxActions: 0,
      itemsInRowsTable: itemsInRowsTable
    },

    filter: {
      fields: [
        {
          name: "active",
          value: 1,
          type: "select",
          label: "main.status",
          opts: {
            style: 'float-label',
            items: [
              { value: -1, label: `${M}all` },
              { value: 1, label: `${M}active` },
              { value: 0, label: `${M}inactive` }
            ],
            isClearable: false
          }
        },
        {
          name: "enrolled",
          value: 1,
          type: "select",
          label: "main.enrollment",
          opts: {
            style: 'float-label',
            items: [
              { value: -1, label: `${M}all` },
              { value: 1, label: `${M}enrolled` },
              { value: 0, label: `${M}notEnrolled`}
            ],
            isClearable: false
          }
        },
        {
          name: "superSectionId",
          value: null,
          type: "select",
          label: "main.grade",
          opts: {
            style: 'float-label',
            path: "/admSuperSection/get?pick=true"
          }
        },
        {
          name: "sectionId",
          value: "",
          type: "select",
          label: "main.section",
          parent: "superSectionId",
          opts: {
            style: 'float-label',
            path: () => { return "/admSection/get?pick=true&parentId=" + context.state.formFilter.superSectionId }
          }
        }
      ],
      buttons: [
        {
          label: 'main.applyFilter',
          onClick: ctx => ctx.btnAction('filter'),
          renderIf: ctx => Number.isInteger(ctx.state.active) || Number.isInteger(ctx.state.enrolled) || Number.isInteger(ctx.state.superSectionId)
        }
      ]
    },

    form: {
      remapOne: (r) => {
        if (r.status >= 0) {
          r.data.superSectionId = { value: r.data.superSectionId, label: r.data.superSectionName }
          r.data.sectionId = { value: r.data.sectionId, label: r.data.sectionName }
          r.data.country = { value: r.data.country, label: r.data.country }
          r.data.birthplace = { value: r.data.birthplace, label: r.data.birthplace }
        }
        return r
      },
      setValuesBeforePost: (v) => {
        if (v.groups) {
          v.groups = v.groups.map(e => {
            e = { ID: e.value, name: e.label, selected: true }
            return e
          })
        }
        return v
      },
      fields: [
        {
          col: 12,
          name: "face",
          value: "",
          type: "dropzone",
          label: "main.photography",
          rules: 'ext:jpeg,jpg,png',
          opts: {
            path: ()=> "admUser/file",
            accept: '.jpeg,.jpg,.png'
          }
        },
        {
          col: 6,
          name: "name",
          value: null,
          type: "text",
          label: "main.name",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "last",
          value: null,
          type: "text",
          label: "main.lastName",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "last2",
          value: null,
          type: "text",
          label: "Apellido M.",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "mail",
          value: null,
          type: "text",
          label: "main.email",
          rules: 'required|email',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "gender",
          value: "",
          type: "select",
          label: "main.gender",
          rules: 'required',
          opts: {
            style: 'float-label',
            items: [
              { value: 'M', label: 'M'},
              { value: 'F', label: 'F'}
            ]
          }
        },
        {
          col: 6,
          name: "separator1",
          type: "separator",
        },
        {
          col: 6,
          name: "inactive",
          value: false,
          type: "switch",
          label: "main.inactive",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "enrolled",
          value: false,
          type: "switch",
          label: "main.registered",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "documenttype",
          value: null,
          type: "text",
          label: "main.documentType",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "documentname",
          value: null,
          type: "text",
          label: "main.documentNumber",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "superSectionId",
          value: "",
          type: "select",
          label: "main.grade",
          opts: {
            style: 'float-label',
            path: "/admSuperSection/get?pick=true"
          }
        },
        {
          col: 6,
          name: "sectionId",
          value: "",
          type: "select",
          label: "main.section",
          parent: "superSectionId",
          opts: {
            style: 'float-label',
            path: () => { return "/admSection/get?pick=true&parentId=" + context.state.form.superSectionId }
          }
        },
        {
          col: 6,
          name: "groups",
          value: "",
          type: "select",
          label: "main.group",
          opts: {
            style: 'float-label',
            isMulti: true,
            path: () => { return "/admGroup/get?staff=2" },
            setOutput: v => v
          }
        },
        {
          col: 6,
          name: "notifModes",
          value: null,
          type: "text",
          label: "main.notifyVia",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "externalId",
          value: null,
          type: "text",
          label: "main.externalId",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "house",
          value: "",
          type: "select",
          label: "House",
          opts: {
            style: 'float-label',
            items: [
              { value: 'Conroy', label: 'Conroy'},
              { value: 'Kufal', label: 'Kufal'},
              { value: 'Evans', label: 'Evans'},
              { value: 'Hope', label: 'Hope'}
            ]
          }
        },
        {
          col: 12,
          name: "label1",
          value: L => `<h5>${L['admUser.personalInformation']}</h5>`,
          type: "label"
        },
        {
          col: 6,
          name: "birthday",
          value: null,
          type: "date",
          label: "main.birthdate",
          placeholder: "YYYY/MM/DD",
          rules: 'required',
          opts: {
            style: 'float-label',
          }
        },
        {
          col: 6,
          name: "natId",
          value: null,
          type: "text",
          label: "main.nationality",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "birthplace",
          value: "",
          type: "select",
          label: "main.birthplace",
          opts: {
            style: 'float-label',
            path: "/general/getcountries",
            remap: (r) => {
              r.data.Results = r.data.map(item => ({ ID: item.id, name: item.name }))
              return r
            }
          }
        },
        {
          col: 6,
          name: "language",
          value: null,
          type: "text",
          label: "main.language",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "livewith",
          value: "PM",
          type: "select",
          label: "main.liveWith",
          opts: {
            style: 'float-label',
            items: [
              { value: 'PM', label: 'Padre y Madre'},
              { value: 'P', label: 'Padre'},
              { value: 'M', label: 'Madre'},
              { value: 'O', label: 'Otro'}
            ]
          }
        },
        {
          col: 6,
          name: "legalwith",
          value: null,
          type: "text",
          label: L => `${L['main.liveWith']} (${L['main.other']})`,
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "address",
          value: null,
          type: "text",
          label: "main.address",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "country",
          value: "",
          type: "select",
          label: "main.birthplace",
          opts: {
            style: 'float-label',
            path: "/general/getcountries",
            remap: (r) => {
              r.data.Results = r.data.map(item => ({ ID: item.id, name: item.name }))
              return r
            }
          }
        },
        {
          col: 6,
          name: "familyPast",
          value: null,
          type: "text",
          label: L => `Familiar ${L['main.exStudent']}`,
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "label2",
          value: L => `<h5>${L['admUser.consents']}</h5>`,
          type: "label"
        },
        {
          col: 6,
          name: "consentEmail",
          value: "",
          type: "select",
          label: "admUser.contactConsentToEmail",
          opts: {
            style: 'float-label',
            items: [
              { value: null, label: '[Sin especificar]'},
              { value: false, label: 'NO'},
              { value: true, label: 'SÍ'}
            ]
          }
        },
        {
          col: 6,
          name: "consentImagesAuth",
          value: "",
          type: "select",
          label: "admUser.imageUseConsent",
          opts: {
            style: 'float-label',
            items: [
              { value: null, label: '[Sin especificar]'},
              { value: false, label: 'NO'},
              { value: true, label: 'SÍ'}
            ]
          }
        },
        {
          col: 6,
          name: "status",
          value: "",
          type: "select",
          label: "main.status",
          rules: "required",
          opts: {
            style: 'float-label',
            items: [
              { value: 0, label: 'Nuevo'},
              { value: 10, label: 'Estudiante'},
              { value: 11, label: 'Ingresante'},
              { value: 12, label: 'Re-ingresante'},
              { value: 20, label: 'Graduado'},
              { value: 21, label: 'Retirado durante año'},
              { value: 22, label: 'Fallecido'},
              { value: 23, label: 'Retirado fin de año'},
              { value: 24, label: 'Retirado - Otros'}
            ]
          }
        }
      ]
    },

    columns: [
      {
        Header: "",
        accessor: "img",
        type: "img"
      },
      {
        Header: "main.ID",
        accessor: "ID"
      },
      {
        Header: "main.name",
        accessor: "name"
      },
      {
        Header: "main.section",
        accessor: "sectionTag"  
      },
      {
        Header: "main.externalId",
        accessor: "externalId"
      },
      {
        Header: "main.document",
        accessor: "doc"
      },
      {
        Header: `${M}mainAdult`,
        accessor: "principalName"
      },
      {
        Header: `${M}documentAdult`,
        accessor: "principalDoc"
      },
    ]
  }
  return moduleConfig
}